import { format } from 'date-fns';

const BASE_COLUMNS = [
    { key: 'state', label: 'Estado' },
    { key: 'customerName', label: 'Cliente' },
    { key: 'email', label: 'Correo' },
    { key: 'phone', label: 'Teléfono' },
    { key: 'orderNumber', label: 'Número de pedido' },
    { key: 'paymentMethod', label: 'Método de pago (pasarela)' },
    { key: 'purchaseDate', label: 'Fecha de compra' },
    { key: 'product', label: 'Producto' },
    { key: 'variant', label: 'Variante' },
    { key: 'quantity', label: 'Cantidad' },
    { key: 'unitPrice', label: 'Precio unitario (MXN)' },
    { key: 'productTotal', label: 'Total del producto (MXN)' },
    { key: 'orderTotal', label: 'Total del pedido (MXN)' }
];

const REPORT_COLUMNS = {
    top_products: [
        { key: 'rank', label: 'Posición Top' },
        { key: 'productUnits', label: 'Unidades vendidas en el periodo' }
    ],
    top_states: [
        { key: 'rank', label: 'Posición Top' },
        { key: 'stateOrderCount', label: 'Pedidos del estado' },
        { key: 'stateSalesTotal', label: 'Venta total del estado (MXN)' }
    ],
    frequent_customers: [
        { key: 'rank', label: 'Posición Top' },
        { key: 'customerPurchases', label: 'Compras del cliente' }
    ]
};

const escapeCsvValue = (value) => {
    if (value === null || value === undefined)
        return '';

    if (typeof value === 'number')
        return String(value);

    let normalized = String(value);
    if (typeof value === 'string' && /^[=+\-@]/.test(normalized))
        normalized = `'${normalized}`;

    return `"${normalized.replace(/"/g, '""')}"`;
};

export const formatDashboardDateKey = date => format(date, 'yyyy-MM-dd');

export const buildDashboardOrdersCsv = (reportType, rows) => {
    const columns = [...(REPORT_COLUMNS[reportType] || []), ...BASE_COLUMNS];
    const lines = [
        columns.map(({ label }) => escapeCsvValue(label)).join(','),
        ...rows.map(row => columns.map(
            ({ key }) => escapeCsvValue(row[key])
        ).join(','))
    ];

    return `\uFEFF${lines.join('\r\n')}`;
};

export const downloadDashboardOrdersCsv = (
    reportType, rows, filename
) => {
    const blob = new Blob(
        [buildDashboardOrdersCsv(reportType, rows)],
        { type: 'text/csv;charset=utf-8;' }
    );
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
